import React, { useState } from 'react';
import { Box, Divider, Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { StyledTextDiv } from 'src/pages/reportUsage/utils/reportUsage.styled';
import CustomLabel from 'src/pages/reportUsage/common/customLabel/CustomLabel';
import TextWithClicks from 'src/pages/reportUsage/common/textWithClicks/TextWithClicks';
import AlertMsg from 'src/pages/reportUsage/common/AlertMsg';
import {
    calculateDiscountPercentage,
    getTotalUsedQuantity,
    getTotalOtherQuantity,
    getTotalExtendedPrice,
    priceFormatObj,
} from 'src/pages/reportUsage/utils/eventHandlerUtil';
import {
    getPriceInNumberDataType,
    noPriceErrorMsg,
} from 'src/pages/reportUsage/utils/dataModificaionUtil';
import DiscountedPriceTemplate from 'src/pages/reportUsage/common/DiscountedPriceTemplate';
import { StyledInput } from 'src/pages/reportUsage/record/components/priceOverride/PriceOverrideTable/index.styled.jsx';
import { isMobileView, setCurrencyFormat } from 'src/utils/util';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
    },
    paper: {
        padding: theme.spacing(2),
    },
    image: {
        width: 128,
        height: 128,
    },
    img: {
        margin: 'auto',
        display: 'block',
        maxWidth: '100%',
        maxHeight: '100%',
    },
    gridPaddingLeft: {
        paddingLeft: '34px',
    },
}));

const RowTemplateDesktop = ({
    key,
    item,
    adjustedPriceChangeHandler,
    itemIdx,
}) => {
    const { t } = useTranslation();
    const classes = useStyles();
    const avenirRegularFont = 'AvenirNextWorld Regular';
    const unitPrice = getPriceInNumberDataType(item.basePrice);
    const [usedValue, setUsedValue] = useState(item.adjustedUsedQtyPrice ? parseFloat(item.adjustedUsedQtyPrice).toFixed(2) : item.adjustedUsedQtyPrice);
    const [otherValue, setOtherValue] = useState(item.adjustedOtherQtyPrice ? parseFloat(item.adjustedOtherQtyPrice).toFixed(2) : item.adjustedOtherQtyPrice);
    const usedQuantity = item.lotSerial && getTotalUsedQuantity(item.lotSerial);
    const otherQuantity =
        item.lotSerial && getTotalOtherQuantity(item.lotSerial);

    const isPriceNotAvailable = item.exclusionStatus === noPriceErrorMsg;

    useEffectWithErrorLogging(() => {
        if (
            !item.adjustedOtherQtyPrice &&
            !item.adjustedUsedQtyPrice &&
            !item.invalidUsedQtyAdjBasePriceMsg &&
            !item.invalidOtherQtyAdjBasePriceMsg
        ) {
            setOtherValue('');
            setUsedValue('');
        }
    }, [item]);

    const adjPriceInputStyleObj = {
        width: '102px',
        height: '33px',
        border: item.invalidOtherQtyAdjBasePriceMsg
            ? '2px solid #FACFD6'
            : '2px solid #EBEDED',
        padding: '6px 8px',
        borderRadius: 6,
        textAlign: 'end',
    };

    return (
        <>
            <Box
                className={classes.paper}
                my={1}
                bgcolor={'#ffffff'}
                boxShadow={2}
                borderRadius={6}
            >
                <Grid
                    container
                    alignItems={'flex-start'}
                    justifyContent={'space-between'}
                >
                    <Grid item lg={4} md={4} sm={4}>
                        <RowItemContainer>
                            <TextWithClicks
                                classes={classes}
                                media={{
                                    titleArea: 0,
                                    buttonnsArea: 6,
                                    xs: 3,
                                    lg: 2,
                                }}
                                justifyContentVal={
                                    isMobileView() ? 'flex-end' : 'center'
                                }
                                typeNonTissue={
                                    item.salesOrg === 'S002' &&
                                    !item.isBundleItem
                                        ? 'NT'
                                        : item.salesOrg === 'S030' && 'T'
                                }
                                typeEA={
                                    item.uom && !item.isBundleItem && item.uom
                                }
                                typeBundle={item.isBundleItem && 'BUNDLE'}
                                totalQtyLabel={`${
                                    usedQuantity + otherQuantity
                                } x`}
                                leftTitle={item.cfn}
                                fromPriceOverride
                            />
                        </RowItemContainer>
                        <CustomLabel
                            fSize={'12px !important'}
                            color={'#140F4B'}
                            letterSpacing={'0px !important'}
                            fWeight={'normal !important'}
                            label={item.description}
                            padding={'5px 0 15px'}
                            fontFamily={avenirRegularFont}
                        />
                    </Grid>
                    <Grid item lg={8} md={8} sm={8}>
                        <PriceTableItemBox>
                            {usedQuantity && usedQuantity > 0 ? (
                                <RowContainer
                                    display={'flex'}
                                    justifyContent={'space-between'}
                                >
                                    <StyledTextDiv
                                        color={'#202124'}
                                        fontSize={'13px'}
                                        width={'100px'}
                                    >
                                        {t('reportUsage.record.priceOverride.AccountOwnedList.index.used')} {usedQuantity}
                                    </StyledTextDiv>
                                    <RowItemContainer width={'100px'}>
                                        {!isPriceNotAvailable && (
                                            <StyledInput
                                                autoComplete="off"
                                                className="adjustedPriceInput"
                                                opacity={'0.4'}
                                                placeholder={item.basePrice}
                                                value={usedValue}
                                                id={`used-${item.cfn}-${itemIdx}`}
                                                onChange={(e) =>
                                                    setUsedValue(e.target.value)
                                                }
                                                onKeyPress={(e) => {
                                                    if (!/[0-9.]/.test(e.key)) {
                                                        e.preventDefault();
                                                    }
                                                }}
                                               // id={key}
                                                style={adjPriceInputStyleObj}
                                                onBlur={(e) =>
                                                    adjustedPriceChangeHandler(
                                                        e,
                                                        item,
                                                        itemIdx,
                                                        'used'
                                                    )
                                                }
                                            />
                                        )}
                                        {item.invalidUsedQtyAdjBasePriceMsg && (
                                            <AlertMessageBox>
                                                <AlertMsg
                                                    message={
                                                        item.invalidUsedQtyAdjBasePriceMsg
                                                    }
                                                />
                                            </AlertMessageBox>
                                        )}
                                    </RowItemContainer>

                                    <RowItemContainer
                                        display={'flex'}
                                        justifyContent={'center'}
                                        width={'160px'}
                                    >
                                        {item.adjustedUsedQtyPrice && (
                                            <StyledTextDiv
                                                color={'#E5047E'}
                                                fontSize={'12px'}
                                            >
                                                {`${calculateDiscountPercentage(
                                                    unitPrice,
                                                    item.adjustedUsedQtyPrice
                                                )} ${t('reportUsage.review.itemsToBeBilled.ItemsToBeBilled.discount')}`}
                                            </StyledTextDiv>
                                        )}
                                    </RowItemContainer>
                                    <RowItemContainer width={'100px'}>
                                        <DiscountedPriceTemplate
                                            isPriceNotAvailable={
                                                isPriceNotAvailable
                                            }
                                            originalPrice={item.basePrice}
                                            adjustedPrice={
                                                item.adjustedUsedQtyPrice
                                            }
                                            modifiedPrice={
                                                item.adjustedUsedQtyPrice
                                                    ? setCurrencyFormat(
                                                        item.adjustedUsedQtyPrice
                                                    )
                                                    : item.basePrice
                                            }
                                        />
                                    </RowItemContainer>
                                    <RowItemContainer width={'100px'}>
                                        <DiscountedPriceTemplate
                                            isPriceNotAvailable={
                                                isPriceNotAvailable
                                            }
                                            originalPrice={item.extPrice}
                                            adjustedPrice={
                                                item.adjustedUsedQtyPrice
                                            }
                                            modifiedPrice={getTotalExtendedPrice(
                                                item.adjustedUsedQtyPrice
                                                    ? item.adjustedUsedQtyPrice
                                                    : item.basePrice,
                                                item.lotSerial,
                                                'used'
                                            )}
                                        />
                                    </RowItemContainer>
                                </RowContainer>
                            ) : null}

                            {usedQuantity &&
                                usedQuantity > 0 &&
                                otherQuantity &&
                                otherQuantity > 0 && (
                                    <DividerContainer>
                                        <Divider orientation="horizontal" />
                                    </DividerContainer>
                                )}
                            {otherQuantity && otherQuantity > 0 ? (
                                <RowContainer
                                    display={'flex'}
                                    justifyContent={'space-between'}
                                >
                                    <StyledTextDiv
                                        color={'#202124'}
                                        fontSize={'13px'}
                                        width={'100px'}
                                    >
                                        {t('reportUsage.record.priceOverride.AccountOwnedList.index.other')} {otherQuantity}
                                    </StyledTextDiv>
                                    <RowItemContainer width={'100px'}>
                                        {!isPriceNotAvailable && (
                                            <StyledInput
                                                autoComplete="off"
                                                className="adjustedPriceInput"
                                                opacity={'0.4'}
                                                placeholder={item.basePrice}
                                                value={otherValue}
                                                id={`other-${item.cfn}-${itemIdx}`}
                                                onChange={(e) =>
                                                    setOtherValue(
                                                        e.target.value
                                                    )
                                                }
                                                onKeyPress={(e) => {
                                                    if (!/[0-9.]/.test(e.key)) {
                                                        e.preventDefault();
                                                    }
                                                }}
                                                style={adjPriceInputStyleObj}
                                                onBlur={(e) =>
                                                    adjustedPriceChangeHandler(
                                                        e,
                                                        item,
                                                        itemIdx,
                                                        'other'
                                                    )
                                                }
                                            />
                                        )}
                                        {item.invalidOtherQtyAdjBasePriceMsg && (
                                            <AlertMessageBox>
                                                <AlertMsg
                                                    message={
                                                        item.invalidOtherQtyAdjBasePriceMsg
                                                    }
                                                />
                                            </AlertMessageBox>
                                        )}
                                    </RowItemContainer>

                                    <RowItemContainer
                                        display={'flex'}
                                        justifyContent={'center'}
                                        width={'160px'}
                                    >
                                        {item.adjustedOtherQtyPrice && (
                                            <StyledTextDiv
                                                color={'#E5047E'}
                                                fontSize={'12px'}
                                            >
                                                {`${calculateDiscountPercentage(
                                                    unitPrice,
                                                    item.adjustedOtherQtyPrice
                                                )}${t('reportUsage.review.itemsToBeBilled.ItemsToBeBilled.discount')}`}
                                            </StyledTextDiv>
                                        )}
                                    </RowItemContainer>
                                    <RowItemContainer width={'100px'}>
                                        <DiscountedPriceTemplate
                                            isPriceNotAvailable={
                                                isPriceNotAvailable
                                            }
                                            originalPrice={item.basePrice}
                                            adjustedPrice={
                                                item.adjustedOtherQtyPrice
                                            }
                                            modifiedPrice={
                                                item.adjustedOtherQtyPrice
                                                    ? setCurrencyFormat(
                                                        item.adjustedOtherQtyPrice
                                                    )
                                                    : item.basePrice
                                            }
                                        />
                                    </RowItemContainer>
                                    <RowItemContainer width={'100px'}>
                                        <DiscountedPriceTemplate
                                            isPriceNotAvailable={
                                                isPriceNotAvailable
                                            }
                                            originalPrice={
                                                item.otherQtyExtPrice
                                            }
                                            adjustedPrice={
                                                item.adjustedOtherQtyPrice
                                            }
                                            modifiedPrice={getTotalExtendedPrice(
                                                item.adjustedOtherQtyPrice
                                                    ? item.adjustedOtherQtyPrice
                                                    : item.basePrice,
                                                item.lotSerial,
                                                'other'
                                            )}
                                        />
                                    </RowItemContainer>
                                </RowContainer>
                            ) : null}
                        </PriceTableItemBox>
                    </Grid>
                </Grid>
            </Box>
        </>
    );
};

export default RowTemplateDesktop;

export const RowItemContainer = styled.div`
    display: ${({ display }) => display};
    justify-content: ${({ justifyContent }) => justifyContent};
    width: ${({ width }) => width};
`;

export const RowContainer = styled.div`
    display: ${({ display }) => display};
    justify-content: ${({ justifyContent }) => justifyContent};
    width: ${({ width }) => width};
`;

export const PriceTableItemBox = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
`;

export const AlertMessageBox = styled.div`
    display: flex;
    width: 240px;
    padding-top: 10px;
`;
export const DividerContainer = styled.div`
    padding: 20px 0;
`;
